import { combineReducers } from "redux";
import constants from "./constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  allAdsList: createApiReducer(constants.GET_ALL_ADS_LIST, {}),
  changeConnectedAdsResult: createApiReducer(constants.CHANGE_CONNECTED_ADS, {}),
});

export default reducers;
